import type { IBranch } from '@/features/user-access/user-access.types';

import { create } from 'zustand';

interface FilterState {
  location?: IBranch;
  date?: Date;
  search?: string;
  timeslot?: number;
  setLocation: (location?: IBranch) => void;
  setDate: (date?: Date) => void;
  setSearch: (search?: string) => void;
  setTimeslot: (timeslot: number) => void;
  reset: () => void;
}

const initialState = {
  location: undefined,
  date: undefined,
  search: undefined,
  timeslot: 15,
};

export const useFilterStore = create<FilterState>()(set => ({
  ...initialState,
  setLocation: location => {
    set({ location });
  },
  setDate: date => {
    set({ date });
  },
  setSearch: search => set({ search }),
  setTimeslot: timeslot => set({ timeslot }),
  reset: () => set(initialState),
}));
